import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface DisassociateCoachWithCoacheeParams {
	readonly coacheeId: string;
}

@Injectable({ providedIn: 'root' })
export class DisassociateCoachWithCoacheeApiMutation extends ApiMutation<
	string,
	DisassociateCoachWithCoacheeParams
> {
	client = 'iam';
	document = gql`
		mutation DisassociateCoachWithCoachee($coacheeId: UUID!) {
			disassociateCoachWithCoachee(coacheeId: $coacheeId)
		}
	`;
	method = 'associateCoachWithCoachee';
}
